import styled from 'styled-components'

import LiveSelect from 'live/components/forms/ui/select'

export const NewGroupScreenContainer = styled.div`
    /* ===== Scrollbar CSS ===== */
    /* Firefox */
    * {
        scrollbar-width: auto;
        scrollbar-color: ${({ theme }) => theme['gray-600']} ${({ theme }) => theme['gray-0']};
    }

    /* Chrome, Edge, and Safari */
    *::-webkit-scrollbar {
        width: 3px;
    }

    *::-webkit-scrollbar-track {
        background: ${({ theme }) => theme['gray-0']};
    }

    *::-webkit-scrollbar-thumb {
        background-color: ${({ theme }) => theme['gray-600']};
        border-radius: 10px;
    }

    display: flex;
    flex-direction: column;
    align-items: center;

    .top-bar {
        width: 100%;
        display: flex;
        justify-content: center;
        background: ${({ theme }) => theme['gray-200']};
    }
`

export const SaveBar = styled.div`
    @media (min-width: 992px) {
        &.container {
            width: 710px;
            width: 940px;
        }
    }
    @media (min-width: 1600px) {
        &.container {
            width: 1140px;
        }
    }
    height: 48px;
    background: ${({ theme }) => theme['gray-200']};
    display: flex;
    align-items: center;
    padding: 0 8px;

    button {
        height: 32px;
        font-size: 15px;
        font-weight: 600;
        padding: 0 24px;
        border: none;
        background: transparent;
        border-radius: 3px;
    }

    .save-button {
        color: ${({ theme }) => theme['gray-0']};
        background: ${({ theme }) => theme['blue-500']};
        border: 1px solid ${({ theme }) => theme['blue-500']};
    }

    .save-button:disabled {
        color: ${({ theme }) => theme['gray-0']};
        background: ${({ theme }) => theme['blue-400']};
        border: 1px solid ${({ theme }) => theme['blue-400']};
    }

    .cancel-button {
        border: 1px solid ${({ theme }) => theme['gray-500']};
        margin-left: 8px;
    }
`

export const TopBar = styled.div`
    width: 100%;
    height: 40px;
    background: ${({ theme }) => theme['gray-200']};
    display: flex;
    justify-content: space-between;
    padding: 0 15px;
    border-bottom: solid 1px ${({ theme }) => theme['gray-300']};
    align-items: center;

    button {
        background: transparent;
        padding: 0;
        margin: 0;
        font-size: 16px;
        color: ${({ theme }) => theme['blue-500']};
        border: none;
    }

    span {
        color: ${({ theme }) => theme['gray-700']};
        font-weight: 600;
        font-size: 16px;
        margin-left: 8px;
    }

    .delete {
        button {
            color: ${({ theme }) => theme['red-500']};
            font-weight: 700;
            font-size: 13px;
            i {
                margin-left: 8px;
            }
        }
    }

    @media (min-width: 992px) {
        &.topbarcontainer {
            width: 750px;
            width: 970px;
        }
    }
    @media (min-width: 1600px) {
        &.topbarcontainer {
            width: 1170px;
        }
    }
`

export const FormContainer = styled.div`
    margin: 32px 0;
    padding: 0 15px;
    display: flex;
    justify-content: space-between;

    .collum {
        width: 46%;
    }

    button {
        background: transparent;
        border: none;
        color: ${({ theme }) => theme['blue-500']};
        padding: 0;
        font-size: 13px;
        font-weight: 600;
        margin-top: 12px;
    }

    .loading-spin {
        width: 100%;
        height: 474px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    @media (min-width: 992px) {
        &.formcontainer {
            width: 750px;
            width: 970px;
        }
    }
    @media (min-width: 1600px) {
        &.formcontainer {
            width: 1170px;
        }
    }
`

export const FormField = styled.div`
    label {
        margin-bottom: 5px;
    }

    .group-name {
        height: 36px;
        margin-bottom: 17px;
    }

    .selected-asset-types {
        width: 100%;
        height: 290px;
        border: 1px solid ${({ theme }) => theme['gray-300']};
        border-radius: 3px;
        overflow-y: auto;

        .asset-types-fields {
            width: 100%;
            height: 32px;
            padding: 0 16px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-bottom: 1px solid ${({ theme }) => theme['gray-300']};

            .close {
                width: 24px;
                height: 32px;
                margin: 0;
                display: none;
            }
        }

        .asset-types-fields:hover {
            .close {
                display: block;
                width: 24px;
                height: 32px;
                margin: 0;
            }
        }
    }

    .selected-users {
        width: 100%;
        height: 367px;
        border: 1px solid ${({ theme }) => theme['gray-300']};
        border-radius: 3px;
        overflow-y: auto;

        .users-fields {
            width: 100%;
            height: 32px;
            padding: 0 16px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-bottom: 1px solid ${({ theme }) => theme['gray-300']};

            .close {
                width: 24px;
                height: 32px;
                margin: 0;
                display: none;
            }
        }

        .users-fields:hover {
            .close {
                display: block;
                width: 24px;
                height: 32px;
                margin: 0;
            }
        }
    }
`

export const SelectEdit = styled(LiveSelect)``
